export const CALL_ANALYTICS_DATE_RANGE_OPTIONS = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'next30Days', label: 'Next 30 Days' },
    { value: 'custom', label: 'Custom Range' },
] as const;

export const CALL_ANALYTICS_DIRECTION_OPTIONS = [
    // { value: '', label: 'All Call Directions' },
    { value: 'OUTBOUND', label: 'Outbound Calls' },
    { value: 'INBOUND', label: 'Inbound Calls' },
    { value: 'MANUAL', label: 'Manual Calls' },
] as const;
